import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import { useRef, useEffect, useState, useContext } from "react"
import { GlobalContext } from './_app'

import Image from "next/image"

import _ from 'lodash'

import { format } from 'date-fns'
import { formatInTimeZone } from "date-fns-tz"

import parse from 'html-react-parser'

import { Header } from "../fuselage/global/header/header"
import { Footer } from '../fuselage/theme/2024/layout/footer/footer'
import { HeaderShim } from "../fuselage/global/header/header"


export default function Agenda ({ sessions, boxouts }) {

    const globals = useContext(GlobalContext)

    // console.log('sessions:', sessions)
    // console.log('boxouts:', boxouts)


    // const specialBoxout = boxouts?.find( entry => entry.id === "177633" )
    // console.log(specialBoxout)

    // BUILD AGENDA
		
	const buildAgenda = ( sessionsData ) => {

		if ( !sessionsData ) return 
		
		const timeslots = _.groupBy(sessionsData, 'beginsAt')
		

		// calculate event days

		function getUniqueDays ( sessionData ) {
			const groupedStartTimes = _.groupBy(sessionData, 'beginsAt')
			const timeCodes = Object.keys(groupedStartTimes)
			const eventDays = _.uniqBy( timeCodes, string => string.slice(0, 10) )	
			return eventDays
		}
		
		const agendaDays = []
		getUniqueDays( sessionsData ).map((timestring, index) => {
			agendaDays.push({ 
				day: format( new Date(timestring), "eeee dd MMMM" ), 
				time: timestring.slice(0, 10), 
				timeslots: [] 
			})
		})

		// console.log('agendaDays:', agendaDays)


        // add filters here +++++++++++


        // build agenda
	
		const agenda = []
		agendaDays.map( day => {
			let slots = []
			for ( const key in timeslots ) {
				if ( key.slice(0, 10) === day.time.slice(0, 10) ) {
					slots.push({ 
						beginsAt: timeslots[key][0].beginsAt, 
						endsAt: timeslots[key][0].endsAt, 
						sessions: timeslots[key]
					})
				}
			}
	
			agenda.push( { ...day , timeslots: slots } )
		})


		// console.log('agenda:', agenda)
		return agenda
	}


    // SPEAKERS

    const handleSessionSpeakers = ( speakerData ) => {
        // console.log('speakerData:', speakerData)
    }


    if ( sessions )return (
        <>
            <Header mainMenu={globals.nodes} />
            <HeaderShim />



            <section className="block bg-wash">
                <div className="container agendaHeader">
                    <div>
                        <p className="fs-1 fw-600 c-primary"><span className="print-only">AviaDev </span>2026 agenda</p>
                    </div>
                    <div className="no-print">
                        <button 
                            className={'button fs-6'}
                            onClick={ ()=> window.print() }
                        >
                            <PrinterIcon />&ensp;Print Agenda
                        </button>
                    </div>
                </div>

                {/* AGENDA */}
				<div className="agenda | section columns-1 gap-sm mt-md">
                    {
                        buildAgenda( sessions ).map( (day, index) => {

                            return (
                                <section key={index} className='day'>
									<p className='dayDivider'> { day.day }</p>
                                    {
										day.timeslots.length ?
										day.timeslots.map( (slot, index) => {

                                            
                                            return (
                                                <>
                                                    {/* REGULAR SESSIONS */}

                                                    <div key={index} className='timeSlot'>

                                                        <div className='timingsAndTags fw-500 c-primary'>
                                                            {formatInTimeZone( new Date(slot.beginsAt), 'Europe/London', "HH:mm" )} - { formatInTimeZone( new Date(slot.endsAt), 'Europe/London', "HH:mm" ) }
                                                        </div>
                                                        
                                                        <div className="sessions">
                                                            {
                                                                slot.sessions.map( (session, index) => {
                                                                    return (
                                                                        <div key={index} className="sessionsWrapper">
                                                                            {
                                                                                slot.sessions.length > 1 &&
                                                                                <div className="sessionStream | fw-600 c-white">Stream {index + 1}</div>
                                                                            }

                                                                            <div className='session | columns-1 gap-xs'>
                                                                                <p className="sessionTitle | fs-4 fw-600 lh-1 c-secondary">{ session.title }</p>

                                                                                {/* <div className='sessionTagGrid'>
                                                                                    [tags]
                                                                                </div> */}
                                                                                
                                                                                <div dangerouslySetInnerHTML={{ __html: session.descriptionRtf }} />
                                        
                                                                                { 
                                                                                    session.speakers.length ?
                                                                                    session.speakers.map( (item, index) => {
                                                                                        if (item.__typename === 'speakers_heading_BlockType') return (
                                                                                            <p key={index} className="fs-sm caps fw-500 c-primary">{ item.heading }</p>
                                                                                        )
                                                                                        return (
                                                                                            <div key={index} className='sessionSpeakerGrid'>
                                                                                                {
                                                                                                    item.speakers.map( speaker => (
                                                                                                        <SpeakerCard key={speaker.id} speaker={speaker} />
                                                                                                    ))
                                                                                                }
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                    : null
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>

                                                    </div>
                                                </>
											)
										}) : <p key={index} className="fs-5 fw-400 py-xs">No sessions available on this day.</p>
									}
                                </section>
                            )
                        
                        })
                    }
                </div>
            </section>

            <Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
        </>
    )


    // fallback

    return (
        <>
            <HeaderShim />
            <section className="block">
                <div className="container">
                    <p className="fs-4 fw-500 c-primary">Agenda currently unavailable</p>
                </div>
            </section>
        </>
    )
}



export const SpeakerCard = ({ speaker, type }) => {

	return (
		<div key={speaker.id} className='sessionSpeaker'>
			{ type ? <p className="c-accent pb-xs">{ type }</p> : null }

            <div className="sessionSpeakerAvatar">
                {
                    speaker.avatar.length ?
                    <Image src={speaker.avatar[0].url} layout={'fill'} alt=""/>
                    : <img src={`/assets/ui/avatar-fallback.png`} alt=""/>
                            
                }
            </div>

			<p className="fw-600">{ speaker.title }</p>
			<p className="fs-sm lh-1 maxw-10">{ speaker.positions[0] && speaker.positions[0].jobTitle }<br />{speaker.positions[0] && speaker.positions[0].organisation}</p>
		</div>
	)
}

const Chevron = () => {
	return (
		<span style={{ display: `inline-block`, height: 12, marginLeft: 6 }}>
			<svg width="100%" height="100%" viewBox="0 0 28 20" style={{ fillRule:`evenodd`, clipRule:`evenodd`, strokeLinecap:`square`, strokeMiterlimit:3 }}>
				<g transform="matrix(1,0,0,1,-4176,-535)">
					<g transform="matrix(0.5,0,0,0.5,2065,250)">
						<path id="dropdown-chevron" d="M4230,580L4250,600L4270,580" style={{ fill:`none`, strokeWidth:`8px` }}/>
					</g>
				</g>
			</svg>
		</span>
	)
}

const PrinterIcon = ({ color }) => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 18" style={{ fillRule:`evenodd`, clipRule:`evenodd`, strokeMiterlimit:1.5 }}>
			<g transform="matrix(1,0,0,1,-2615,-138)">
				<g id="printer" transform="matrix(0.557918,0,0,0.557918,1290.56,6.44085)">
					<path d="M2381.63,259.726L2375.8,259.726L2375.8,244.224L2400.43,244.224L2400.43,259.726L2394.6,259.726L2394.6,253.717L2381.63,253.717L2381.63,259.726Z" style={{ fill:`none`, stroke: color ? color : 'white', strokeWidth:1.79 }}/>
					<g transform="matrix(0.526495,0,0,0.745724,1130.79,71.5936)">
						<rect x="2375.8" y="244.224" width="24.631" height="15.502" style={{ fill:`none`, stroke: color ? color : 'white', strokeWidth:2.78 }}/>
					</g>
					<g transform="matrix(0.526495,0,0,0.327579,1130.79,159.143)">
						<rect x="2375.8" y="244.224" width="24.631" height="15.502" style={{ fill:`none`, stroke: color ? color : 'white', strokeWidth:4.09 }}/>
					</g>
					<circle cx="2381.62" cy="248.903" r="0.906" style={{ fill: color ? color : 'white' }}/>
					<g transform="matrix(1,0,0,1,2.95813,0)">
						<circle cx="2381.62" cy="248.903" r="0.906" style={{ fill: color ? color : 'white' }}/>
					</g>
				</g>
			</g>
		</svg>
	)
}

const SummarySession = ({ times, title }) => {
    return (
        <div className="timeSlot">
            <div className='timingsAndTags fw-500 c-primary'>
                {times}
            </div>

            <div className='session | columns-1 gap-xs'>
                <p className="sessionTitle | fs-4 fw-600 lh-1 c-secondary">{title}</p>
            </div>
        </div>
    )
}



export async function getStaticProps() {

    const agendaData = await craftApolloClient().query({
        query: gql`
            query Page {
                sessions: entries(site: "aviadev", section: "aviadevAgenda2026", type: "session") {
                    ... on aviadevAgenda2026_session_Entry {
                        id
                        title
                        beginsAt
                        endsAt
                        descriptionRtf
                        speakers {
                        ... on speakers_heading_BlockType {
                            id
                            heading
                        }
                        ... on speakers_speakers_BlockType {
                            id
                            speakers {
                            ... on profiles_profile_Entry {
                                id
                                title
                                positions {
                                ... on positions_BlockType {
                                    id
                                    jobTitle
                                    organisation
                                }
                                }
                                avatar {
                                ... on avatars_Asset {
                                    id
                                    url
                                    width
                                    height
                                }
                                }
                            }
                            }
                        }
                            }
                            aviadevLocation {
                            ... on aviadevLocations_Category {
                                id
                                title
                            }
                        }
                            aviadevTopics {
                            ... on aviadevTopics_Category {
                                id
                                title
                            }
                        }
                    }
                }
                
            }
        `
    })

    return { 
        props: { 
            sessions: agendaData.data.sessions,
            // boxouts: agendaData.data.boxouts
        }
    }
}

